var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41757 11.0695C2.93323 10.38 3.91026 10.239 4.59982 10.7547C4.65863 10.7986 4.71426 10.8467 4.76629 10.8985L9.75741 15.8693L19.0633 2.97278C19.5614 2.28257 20.5247 2.12679 21.2149 2.62484C21.267 2.66244 21.3167 2.70327 21.3637 2.74708C22.0957 3.42918 22.2107 4.54741 21.6328 5.36419L10.648 20.8897C10.4353 21.1902 10.0193 21.2615 9.71869 21.0488C9.68598 21.0257 9.65542 20.9996 9.62738 20.971L2.59849 13.7918C1.87524 13.0531 1.79843 11.8975 2.41757 11.0695Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark-white.65b6299577cb08e2f729dcdb95f7234f.svg";